import './App.css';
import MainRoute from './routes';
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { useEffect } from 'react';
import { socket } from './redux/config';

function App() {
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      socket.emit("connected", userId);
      console.log(userId, "emmited by socket");
    }
  }, []);
  return (
    <Provider store={store}>
      <div className="App">
        <MainRoute />
      </div>
    </Provider>
  );
}

export default App;
